import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M17.5 22h.5c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V7.5L14.5 2H6c-.5 0-1 .2-1.4.6C4.2 3 4 3.5 4 4v3",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 20v-1a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 20v-1a2 2 0 1 0-4 0v1a2 2 0 1 0 4 0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 19v-3a6 6 0 0 1 12 0v3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileAudio";
const FileAudio = memo(themed(Icon));
export {
  FileAudio
};
//# sourceMappingURL=file-audio.js.map
